// extracted by mini-css-extract-plugin
module.exports = {"Board":"Game_Board__1zalr","row":"Game_row__1cUNs","counter":"Game_counter__1pVfP","WinOverly":"Game_WinOverly__33zpt","Win":"Game_Win__3_kmN","WinText":"Game_WinText__3cejW"};